<template>
	<div>
		<label>{{$t('selectRule')}}</label>
		<div class="container">
			<div class="row">
				<div class="col-sm-12" v-for="(rule, type) in rules" :key="type">
					<div class="checkbox mt-2" @click="toggle(rule)">
						<div>
							<i class="far fa-square" v-if="!isExist(rule)"/> 
							<i class="fas fa-check-square selected" v-else></i> 
							&nbsp;<img v-if="rule.get('icon')" :src="rule.get('icon').url()" height="28"> {{rule.get('name_th')}}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'underscore';
export default {
  props: {
    value: {
		default: () => []
	},
	apartmentId:{},
	userId: {}
	},
	data() {
		return {
			formFacility: {},
			newItem: '',
			isNewItemSaved: true,
			isSaving: false,
			rules: []
		}
	},
	async created() {
		let query = new this.Parse.Query('ApartmentRule')
		query.ascending('order')
		try {
			let rules = await query.find()
			this.rules = rules
		} catch (error) {
			alert('error')
		}
	},
	methods: {
		toggle(fac) {
			let isFound = _.find(this.value, f => {
				return f.id === fac.id
			})
			if(!isFound) {
				this.value.push(fac)
				this.$emit('input', this.value)
			}else{
				this.$emit('input', _.reject(this.value, f => {
					return f.id === fac.id
				}))
			}
		},
		isExist(fac) {
			let result = _.findWhere(this.value, {id: fac.id})
			return result
		}
	}
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/color.scss';

.add-facility {
	margin: 0;
	padding: 0;
}

.add-facility-btn {
	width: 100%;
	margin: 0;
	padding: 0;
}

.facility-input {
	display: inline;
	margin-right: 5px;
}

.fp-selectable {
	cursor: pointer;
}

.checkbox {
	cursor: pointer;
}

.selected {
	color: $primary-color;
}

.add-btn {
	cursor: pointer;
	color: $primary-color;
	margin-left: 30px;
}
</style>
